import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LocaleService {
  private translateService = inject(TranslateService);
  private titleService = inject(Title);

  private language!: string;
  private languageCode!: string;
  private countryCode!: string;

  translateInstant(key: string): string {
    return this.translateService.instant(key);
  }

  translateGet(key: string): Observable<string>;
  translateGet(key: string[]): Observable<Record<string, string>>;
  translateGet(
    key: string | string[],
  ): Observable<string | Record<string, string>> {
    return this.translateService.get(key);
  }

  setTitle(key: string): void {
    this.titleService.setTitle(this.translateInstant(key));
  }

  getLanguage() {
    return this.language;
  }

  getLanguageCode() {
    return this.languageCode;
  }

  getCountry() {
    return this.countryCode;
  }

  setLanguage(locale: string): void {
    this.language = locale;

    const parts = locale.split('-');
    this.languageCode = parts[0].toLowerCase();
    this.countryCode = (parts[1] || '').toUpperCase();
  }
}
